/** Minimal player profile for coaches acting as players when no linked profile exists. */
export const buildFallbackPlayerProfile = (user: {
  id: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  role?: string;
}) => ({
  id: user.id,
  userId: user.id,
  playerIdCode: user.email || `COACH-${user.id}`,
  firstName: user.firstName || user.email?.split('@')[0] || 'Coach',
  lastName: user.lastName || '',
  primarySport: 'Badminton',
  user: {
    id: user.id,
    email: user.email,
    firstName: user.firstName || user.email?.split('@')[0] || 'Coach',
    lastName: user.lastName || '',
    role: user.role,
  },
});

export const loadPlayerProfileForUser = async (
  userId: string,
  token?: string | null,
  allowFallback = false,
  user?: { id: string; email?: string; firstName?: string; lastName?: string; role?: string }
) => {
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const response = await fetch(`/api/players/me?userId=${userId}`, { headers });
  const data = await response.json();
  if (data?.success && data.data?.id) {
    return data.data;
  }
  if (allowFallback && user) {
    return buildFallbackPlayerProfile(user);
  }
  return null;
};
